module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--7-bb39851fcda31f39482914b66b533b33.jpg";